module.exports = __webpack_public_path__ + "assets/img/c7cf6756b572503b63794ffe7afd4445.svg";